module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "church-icon.bee7b7ec.png";